package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Account(
  public val id: String,
  public val email: String,
  public val password_hash: String,
  public val salt: String,
  public val biometric_enrolled: Long,
  public val created_at: Long,
  public val last_login_at: Long?,
)
